import {client } from '../client/client';
import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import { reducer as formReducer } from 'redux-form';
import {CleaningReducer} from '../src/reducers/CleaningReducer';
import rootReducer from '../src/reducers';

export const store = createStore(
    // combineReducers({
    //     apollo: client.reducer(),
    //     form: formReducer,
    //     cleaning: cleaningReducer
    // }), //initial state
    rootReducer,
    compose(
        applyMiddleware(client.middleware()),
        (typeof window !== 'undefined' && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined') ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
    )
)





// WEBPACK FOOTER //
// ./redux/store.js